// splitting this code into a file so we can re-use it in the react route we have created as needs to be loaded there too
import './horrible-asset-loader';
import './setup-for-angular';
import { runApp } from './assets/js/app';

runApp();
